import { createContext, useContext } from 'react';

import type { InactivityTimer } from '@/shared/lib/inactivity-timer';

export type InactivityTimerContextValue = Omit<InactivityTimer, 'init' | 'destroy'>;

export const InactivityTimerContext = createContext<InactivityTimerContextValue | null>(null);

export function useInactivityTimer() {
    const context = useContext(InactivityTimerContext);

    if (!context) {
        throw new Error('useInactivityTimer must be used within InactivityTimerProvider');
    }

    return context;
}
